import React, { useState, useEffect } from "react";
import Admin from "./Admin";
import "../../styles/admin.css";

export default function AdminMatches({ addToast }) {
  const [matches, setMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [teams, setTeams] = useState([]);
  const [leagues, setLeagues] = useState([]);

  // Szükséges adatok
  const [leagueId, setLeagueId] = useState(null);
  const [homeTeamId, setHomeTeamId] = useState(null);
  const [awayTeamId, setAwayTeamId] = useState(null);
  const [matchDate, setMatchDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [homeScore, setHomeScore] = useState("");
  const [awayScore, setAwayScore] = useState("");
  const [cardsCount, setCardsCount] = useState("");



  // Mérkőzés szerkesztésének mentése
  const handleSave = () => {
    if (!selectedMatch) {
      const newMatch = {
        league_id: leagueId,
        home_team_id: homeTeamId,
        away_team_id: awayTeamId,
        match_date: matchDate,
        start_time: startTime
      };

      fetch("https://focifanatik.hu/api/admin_add_matches.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newMatch)
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            addToast("Új mérkőzés sikeresen hozzáadva!", "success")
            handleCloseModal();

            // Frissítsük a listát
            fetch("https://focifanatik.hu/api/admin_matches.php")
              .then(r => r.json())
              .then(d => setMatches(d));
          } else {
            addToast("Hiba!", "warning")
          }
        })
        .catch(err => console.error("Hálózati hiba:", err));

      return; // itt megállunk, nem megyünk tovább a szerkesztéses részre
    };



    // Csak a módosított mezőket küldjük el
    const updatedData = {};
    if (leagueId !== selectedMatch.league_id) updatedData.league_id = leagueId;
    if (homeTeamId !== selectedMatch.home_team_id) updatedData.home_team_id = homeTeamId;
    if (awayTeamId !== selectedMatch.away_team_id) updatedData.away_team_id = awayTeamId;
    if (matchDate !== selectedMatch.match_date) updatedData.match_date = matchDate;
    if (startTime !== selectedMatch.start_time) updatedData.start_time = startTime;
    if (homeScore !== "") {
      updatedData.home_score = Number(homeScore);
    }

    if (awayScore !== "") {
      updatedData.away_score = Number(awayScore);
    }

    if (cardsCount !== "") {
      updatedData.cards_count = Number(cardsCount);
    }


    if (Object.keys(updatedData).length === 0) {
      addToast("Nem történt módositás!", "warning")
      return;
    }

    fetch(`https://focifanatik.hu/api/admin_update_matches.php?id=${selectedMatch.id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          addToast("Sikeres mentés!", "success")
          handleCloseModal();

          fetch("/admin_matches.php")
            .then((r) => r.json())
            .then((d) => setMatches(d));
        } else {
          addToast("Hiba!", "warning")
        }
      })
      .catch((err) => console.error("Hálózati hiba:", err));

  };

  // Mérkőzések törlése
  const handleDelete = (id) => {
    if (!window.confirm("Biztosan törölni szeretnéd ezt a meccset?")) return;

    fetch(`https://focifanatik.hu/api/admin_delete_matches.php?id=${id}`, {
      method: "DELETE",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          addToast("Sikeres törlés!", "success")
          // újratöltjük a listát
          setMatches(matches.filter(team => team.id !== id));
        } else {
          addToast("Hiba!", "warning")
        }
      })
      .catch(err => console.error("Hálózati hiba:", err));
  };

  // Mérkőzések lekérése GET
  useEffect(() => {
    // FONTOS: pontos URL
    fetch("https://focifanatik.hu/api/admin_matches.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
        setMatches(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, []);


  // Ligák lekérése
  useEffect(() => {
    fetch("https://focifanatik.hu/api/admin_leagues.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Kapott adatok:", data);
        setLeagues(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, []);



  // Csapatok lekérése
  useEffect(() => {
    if (!leagueId) {
      setTeams([]); // üres lista, ha nincs kiválasztva
      return;
    }
    setHomeTeamId("");
    setAwayTeamId("");

    fetch(`https://focifanatik.hu/api/admin_teams_by_league.php?league_id=${leagueId}`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Meccsek a ligákhoz:", leagueId, data);
        setTeams(data);
      })
      .catch((err) => {
        console.error("Hiba a lekéréskor:", err);
        setTeams([]);
      })
  }, [leagueId]);

  // Modal ablakok megnyitása/bezárása
  const handleOpenModal = (match) => {
    setSelectedMatch(match);
    setLeagueId(match.league_id);
    setHomeTeamId(match.home_team_id);
    setAwayTeamId(match.away_team_id);
    setMatchDate(match.match_date);
    setStartTime(match.start_time);
    setHomeScore(match.home_score);
    setAwayScore(match.away_score);
    setCardsCount(match.cards_count);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedMatch(null);
  };

  return (
    <div className="admin-page">
      <Admin />
      <main className="admin-content">
        <header className="admin-header">
          <h3>🏆 Mérkőzések kezelése</h3>
        </header>


        <section className="admin-main">
          <p className="text-muted">Itt tudod kezelni a mérkőzéseket.</p>

          <button
            className="btn btn-success mb-3"
            onClick={() => {
              // kiürítjük a mezőket és megnyitjuk az üres modalt
              setSelectedMatch(null);
              setLeagueId("");
              setHomeTeamId("");
              setAwayTeamId("");
              setMatchDate("");
              setStartTime("");
              setHomeScore("");
              setAwayScore("");
              setCardsCount("");
              setShowModal(true);
            }}
          >
            <i className="bi bi-plus-circle"></i> Új mérkőzés hozzáadása
          </button>

          <div className="table-responsive mt-1">

            <table className="table table-striped text-center align-middle">
              <thead className="table-success">
                <tr>
                  <th>ID</th>
                  <th>League ID</th>
                  <th>Home Team Name</th>
                  <th>Away Team Name</th>
                  <th>Match_date</th>
                  <th>Start_Time</th>
                  <th>Home Score</th>
                  <th>Away Score</th>
                  <th>Cards Count</th>
                  <th>Szavazatok</th>
                  <th>Műveletek</th>
                </tr>
              </thead>
              <tbody>
                {matches.map((l) =>
                  <tr key={l.id}>
                    <td>{l.id}</td>
                    <td>{l.league_id}</td>
                    <td>{l.home_team_name}</td>
                    <td>{l.away_team_name}</td>
                    <td>{l.match_date}</td>
                    <td>{l.start_time}</td>
                    <td>{l.home_score}</td>
                    <td>{l.away_score}</td>
                    <td>{l.cards_count}</td>
                    <td>{l.vote_count}</td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-sm btn-warning" onClick={() => handleOpenModal(l)}>
                          <i className="bi bi-pencil-square"></i> Szerkesztés
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(l.id)}>
                          <i className="bi bi-trash"></i> Törlés
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>

      {showModal && (
        <>
          {/* Sötét háttér */}
          <div className="custom-modal-backdrop"></div>

          <div className="custom-modal d-flex justify-content-center align-items-center">
            <div className="custom-modal-content">

              {/* CÍM */}
              <div className="custom-modal-header">
                <h5 className="modal-title-custom">
                  {selectedMatch ? "Mérkőzés szerkesztése" : "Új mérzkőzés"}
                </h5>
                <button className="close-btn" onClick={handleCloseModal}>×</button>
              </div>


              {/* TARTALOM */}
              <div className="custom-modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">League</label>
                    <select
                      className="form-select"
                      value={leagueId}
                      onChange={(e) => setLeagueId(e.target.value)}>
                      <option value="">-- Válassz ligát --</option>
                      {leagues.map((m) =>
                        <option key={m.id} value={m.id}> {m.name}</option>
                      )}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Home Team</label>
                    <select
                      className="form-select"
                      value={homeTeamId}
                      onChange={(e) => setHomeTeamId(e.target.value)}>
                      <option value="">-- Válassz hazai csapatot --</option>
                      {teams.map((m) =>
                        <option key={m.id} value={m.id}>{m.short_name}</option>
                      )}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Away Team</label>
                    <select
                      className="form-select"
                      value={awayTeamId}
                      onChange={(e) => setAwayTeamId(e.target.value)}>
                      <option value="">-- Válassz vendég csapatot --</option>
                      {teams.map((m) =>
                        <option key={m.id} value={m.id}>{m.short_name}</option>
                      )}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Match Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={matchDate}
                      onChange={(e) => setMatchDate(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Start Time</label>
                    <input
                      type="time"
                      className="form-control"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                    />
                  </div>

                  {selectedMatch && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">Home Score</label>
                        <input
                          type="number"
                          className="form-control"
                          value={homeScore}
                          onChange={(e) => setHomeScore(e.target.value)}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Away Score</label>
                        <input
                          type="number"
                          className="form-control"
                          value={awayScore}
                          onChange={(e) => setAwayScore(e.target.value)}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Cards Count</label>
                        <input
                          type="number"
                          className="form-control"
                          value={cardsCount}
                          onChange={(e) => setCardsCount(e.target.value)}
                        />
                      </div>
                    </>
                  )}
                </form>
              </div>

              {/* LÁB */}
              <div className="custom-modal-footer">
                <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                  Mégse
                </button>
                <button className="pretty-btn save-btn" onClick={handleSave}>
                  Mentés
                </button>
              </div>


            </div>
          </div>
        </>
      )}
    </div>
  );
}
